import React from 'react'
import { Link, BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from '../src/Components/Home'
import Works from '../src/Components/Works'
import AboutMe from '../src/Components/AboutMe'
import Contact from '../src/Components/Contact'
import NoPage from '../src/Components/NoPage'
import './App.css'
import HomePage from '../src/Pages/HomePage'
import WorksPage from '../src/Pages/WorksPage'
import AboutPage from '../src/Pages/AboutPage'
import ContactsPage from '../src/Pages/ContactsPage'




const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' Component={HomePage} />
          <Route path='/works' Component={WorksPage} />
          <Route path='/about' Component={AboutPage} />
          <Route path='/contacts' Component={ContactsPage} />
          <Route path='*' Component={NoPage} />

        </Routes>

      </BrowserRouter>
    </>
  )



}

export default App